/* shop/components/delivery/StandardDelivery.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	component_subscribe,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	listen_dev,
	noop,
	prop_dev,
	safe_not_equal,
	set_data_dev,
	space,
	text,
	validate_slots,
	validate_store
} from "svelte/internal";

import orderStore, {
	isDeliveryAvailableForPersonalPickup
} from "./../../orderStore";

const file = "shop/components/delivery/StandardDelivery.svelte";

// (19:4) {#if deliveryItem.subtitle}
function create_if_block_1(ctx) {
	let small;
	let t_value = /*deliveryItem*/ ctx[0].subtitle + "";
	let t;

	const block = {
		c: function create() {
			small = element("small");
			t = text(t_value);
			add_location(small, file, 19, 8, 596);
		},
		m: function mount(target, anchor) {
			insert_dev(target, small, anchor);
			append_dev(small, t);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*deliveryItem*/ 1 && t_value !== (t_value = /*deliveryItem*/ ctx[0].subtitle + "")) set_data_dev(t, t_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(small);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(19:4) {#if deliveryItem.subtitle}",
		ctx
	});

	return block;
}

// (22:4) {#if deliveryItem.price}
function create_if_block(ctx) {
	let t0;
	let t1_value = /*deliveryItem*/ ctx[0].price + "";
	let t1;
	let t2;

	const block = {
		c: function create() {
			t0 = text(": ");
			t1 = text(t1_value);
			t2 = text(" Kč");
		},
		m: function mount(target, anchor) {
			insert_dev(target, t0, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, t2, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*deliveryItem*/ 1 && t1_value !== (t1_value = /*deliveryItem*/ ctx[0].price + "")) set_data_dev(t1, t1_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(t2);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(22:4) {#if deliveryItem.price}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let input;
	let input_id_value;
	let input_checked_value;
	let t0;
	let label;
	let t1_value = /*deliveryItem*/ ctx[0].title + "";
	let t1;
	let t2;
	let t3;
	let label_for_value;
	let mounted;
	let dispose;
	let if_block0 = /*deliveryItem*/ ctx[0].subtitle && create_if_block_1(ctx);
	let if_block1 = /*deliveryItem*/ ctx[0].price && create_if_block(ctx);

	const block = {
		c: function create() {
			input = element("input");
			t0 = space();
			label = element("label");
			t1 = text(t1_value);
			t2 = space();
			if (if_block0) if_block0.c();
			t3 = space();
			if (if_block1) if_block1.c();
			attr_dev(input, "type", "radio");
			attr_dev(input, "class", "radok");
			attr_dev(input, "id", input_id_value = "delivery_" + /*deliveryItem*/ ctx[0].id);
			input.checked = input_checked_value = /*$orderStore*/ ctx[1].delivery_title == /*deliveryItem*/ ctx[0].title;
			add_location(input, file, 8, 0, 171);
			attr_dev(label, "for", label_for_value = "delivery_" + /*deliveryItem*/ ctx[0].id);
			add_location(label, file, 16, 0, 490);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, input, anchor);
			insert_dev(target, t0, anchor);
			insert_dev(target, label, anchor);
			append_dev(label, t1);
			append_dev(label, t2);
			if (if_block0) if_block0.m(label, null);
			append_dev(label, t3);
			if (if_block1) if_block1.m(label, null);

			if (!mounted) {
				dispose = listen_dev(input, "click", /*click_handler*/ ctx[2], false, false, false, false);
				mounted = true;
			}
		},
		p: function update(ctx, [dirty]) {
			if (dirty & /*deliveryItem*/ 1 && input_id_value !== (input_id_value = "delivery_" + /*deliveryItem*/ ctx[0].id)) {
				attr_dev(input, "id", input_id_value);
			}

			if (dirty & /*$orderStore, deliveryItem*/ 3 && input_checked_value !== (input_checked_value = /*$orderStore*/ ctx[1].delivery_title == /*deliveryItem*/ ctx[0].title)) {
				prop_dev(input, "checked", input_checked_value);
			}

			if (dirty & /*deliveryItem*/ 1 && t1_value !== (t1_value = /*deliveryItem*/ ctx[0].title + "")) set_data_dev(t1, t1_value);

			if (/*deliveryItem*/ ctx[0].subtitle) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(label, t3);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*deliveryItem*/ ctx[0].price) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					if_block1.m(label, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*deliveryItem*/ 1 && label_for_value !== (label_for_value = "delivery_" + /*deliveryItem*/ ctx[0].id)) {
				attr_dev(label, "for", label_for_value);
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(input);
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(label);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

const type = "standard";

function instance($$self, $$props, $$invalidate) {
	let $orderStore;
	validate_store(orderStore, 'orderStore');
	component_subscribe($$self, orderStore, $$value => $$invalidate(1, $orderStore = $$value));
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('StandardDelivery', slots, []);
	let { deliveryItem } = $$props;

	$$self.$$.on_mount.push(function () {
		if (deliveryItem === undefined && !('deliveryItem' in $$props || $$self.$$.bound[$$self.$$.props['deliveryItem']])) {
			console.warn("<StandardDelivery> was created without expected prop 'deliveryItem'");
		}
	});

	const writable_props = ['deliveryItem'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<StandardDelivery> was created with unknown prop '${key}'`);
	});

	const click_handler = () => {
		orderStore.setDelivery(deliveryItem.id, type, deliveryItem.title, deliveryItem.price, {}, deliveryItem.type_is_personal_pickup || false);
	};

	$$self.$$set = $$props => {
		if ('deliveryItem' in $$props) $$invalidate(0, deliveryItem = $$props.deliveryItem);
	};

	$$self.$capture_state = () => ({
		orderStore,
		isDeliveryAvailableForPersonalPickup,
		deliveryItem,
		type,
		$orderStore
	});

	$$self.$inject_state = $$props => {
		if ('deliveryItem' in $$props) $$invalidate(0, deliveryItem = $$props.deliveryItem);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [deliveryItem, $orderStore, click_handler];
}

class StandardDelivery extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, { deliveryItem: 0 });

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "StandardDelivery",
			options,
			id: create_fragment.name
		});
	}

	get deliveryItem() {
		throw new Error("<StandardDelivery>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set deliveryItem(value) {
		throw new Error("<StandardDelivery>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default StandardDelivery;